import { render, staticRenderFns } from "./cModalServicio.vue?vue&type=template&id=d1838ede"
import script from "./cModalServicio.vue?vue&type=script&lang=js"
export * from "./cModalServicio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports